import React from "react";
import { connect } from "react-redux";
import { removeData } from "../../store/action";
import { withRouter } from "react-router-dom";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { AdminUrls } from "../../network/config";
import axios from "axios";
import ViewModal from "./_modals/view";

const localizer = momentLocalizer(moment);

const loadEvent_Url = AdminUrls.ADMIN.CPDADMIN;

class MonthlyView extends React.Component {
  constructor() {
    super();
    this.myEventList = this.myEventList.bind(this);
    this.modalOpen = this.modalOpen.bind(this);
    this.listViewModalShownClose = this.listViewModalShownClose.bind(this);

    this.state = {
      knowledgeInfoModalShown: false,
      accountingInfoModalShown: false,
      atiCodeInfoModalShown: false,
      atiCodeProfessionalEthicsModalShown: false,
      unauthorized: false,
      events_info: [],
      currentDate: "",

      listViewModalShown: false,
      listViewDataCourseName: "",
      listViewDatastartDate: "",
      listViewDatacourseLocation: "",
      listViewDatacourseType: "",
      listViewDatahost: "",
      listViewDatacpdFormat: "",
      listViewDatavenue: "",
      listViewDatatrainer: "",
      listViewDatacourseDescription: "",
    };
    this.controller = new AbortController();
  }

  componentDidMount() {
    this.myEventList(new Date());
  }

  myEventList(date) {
    let c_date = date.getMonth() + 1 + "|" + date.getFullYear();

    axios
      .get(loadEvent_Url, {
        params: {
          page: 1,
          pageSize: 1,
          monthlyView: c_date,
        },
        method: "GET",
        signal: this.controller.signal,
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        let data = response?.data?.Items;
        let arr = [];
        if (data && data.length) {
          for (let i = 0; i < data.length; i++) {
            let newdate = new Date(data[i]?.StartDate);
            let year = newdate.getFullYear();
            let mon = newdate.getMonth();
            let d = newdate.getDate();
            let h = newdate.getHours();
            let min = newdate.getMinutes();

            let obj = {
              data: data[i],
              title:
                data[i]?.CourseName +
                (h && h > 9
                  ? " (" + h + ":" + min + ")"
                  : " (" + h + "0:0" + min + ")"),
              allDay: false,
              start: new Date(year, mon, d, h, min),
              end: new Date(year, mon, d, h, min),
            };

            arr.push(obj);
          }
          this.setState({
            events_info: arr,
          });
        }
      })

      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  modalOpen(e) {
    this.setState({
      listViewDataCourseName: e?.data?.CourseName,
      listViewDatastartDate: e?.data?.StartDate,
      listViewDatacourseLocation: e?.data?.Expr1,
      listViewDatacourseType: e?.data?.Description,
      listViewDatahost: e?.data?.Name,
      listViewDatacpdFormat: e?.data?.FormatName,
      listViewDatavenue: e?.data?.Venue,
      listViewDatatrainer: e?.data?.Trainer,
      listViewDatacourseDescription: e?.data?.CourseDescription,
      listViewModalShown: true,
    });
  }
  componentWillUnmount() {
    this.controller.abort();
  }
  listViewModalShownClose() {
    this.setState({ listViewModalShown: false });
  }
  render() {
    return (
      <div>
        {" "}
        <div>
          <Calendar
            localizer={localizer}
            events={this?.state?.events_info}
            startAccessor="start"
            endAccessor="end"
            style={{ height: 500 }}
            onSelectEvent={(e) => this.modalOpen(e)}
            onNavigate={(e) => this.myEventList(new Date(e))}
          />
        </div>
        <ViewModal
          show={this.state.listViewModalShown}
          onHide={this.listViewModalShownClose}
          startdate={this.state.listViewDatastartDate}
          coursename={this.state.listViewDataCourseName}
          courselocation={this.state.listViewDatacourseLocation}
          coursetype={this.state.listViewDatacourseType}
          host={this.state.listViewDatahost}
          cpdformat={this.state?.listViewDatacpdFormat}
          venue={this.state.listViewDatavenue}
          trainer={this.state.listViewDatatrainer}
          description={this.state.listViewDatacourseDescription}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(removeData()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MonthlyView));
